import styled from "styled-components";

export const Container = styled.main`
  display: block;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
`;
